import React from 'react'
import { useParams } from 'react-router';
import { editPartner } from '../../../../Apis/partnersApi';
import Form from './Form'

export default function EditPartner() {
    const { id } = useParams();
    // onsubmit
    const onSubmit = async (e, data) => {
        e.preventDefault();
        //to send request
        data.append("_method", "patch");
        return await editPartner(id , data).then(res => {
            return 'done';      
        }).catch(err => {
            console.log(err.response);
            return err.response.data.errors;
        })
    };

    return (
        <Form onSubmit={onSubmit}></Form>
    )
}
